module.exports = __webpack_public_path__ + "static/media/mitsubishi-headset.36dac54d.svg";